const POST_LOGIN_NAVIGATION_KEY = "yb:post-login-navigation-diagnostic";
const INTERNAL_FLIGHT_QUERY_KEYS = new Set(["_rsc", "__flight__", "__nextDataReq"]);

function isEnabled() {
  return process.env.NODE_ENV !== "production" && typeof window !== "undefined";
}

function describeUrl(input) {
  try {
    const url = new URL(input, window.location.origin);
    const queryKeys = Array.from(url.searchParams.keys()).sort();
    return {
      pathname: url.pathname,
      queryKeys,
      visibleUrlContainsFlightParam: queryKeys.some((key) => INTERNAL_FLIGHT_QUERY_KEYS.has(key)),
    };
  } catch {
    return {
      pathname: null,
      queryKeys: [],
      visibleUrlContainsFlightParam: false,
    };
  }
}

// Development-only redirect breadcrumbs. Values, auth data, cookies, and the
// response body are intentionally excluded.
export function recordPostLoginNavigation({ initiatedBy, target } = {}) {
  if (!isEnabled()) return;
  const payload = {
    initiatedBy: initiatedBy || "unknown",
    destination: describeUrl(target || window.location.href),
  };
  try {
    window.sessionStorage.setItem(POST_LOGIN_NAVIGATION_KEY, JSON.stringify(payload));
  } catch {
    // Diagnostics must never affect sign-in.
  }
  console.info("[POST_LOGIN_NAV]", { phase: "start", ...payload });
}

export function logPostLoginNavigationResult() {
  if (!isEnabled()) return;
  let payload = null;
  try {
    payload = JSON.parse(window.sessionStorage.getItem(POST_LOGIN_NAVIGATION_KEY) || "null");
    window.sessionStorage.removeItem(POST_LOGIN_NAVIGATION_KEY);
  } catch {
    return;
  }
  if (!payload) return;

  console.info("[POST_LOGIN_NAV]", {
    phase: "document_ready",
    initiatedBy: payload.initiatedBy || "unknown",
    destination: payload.destination || describeUrl(window.location.href),
    resultingDocumentContentType: document.contentType || null,
    visible: describeUrl(window.location.href),
  });
}
